var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookCircleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9958 30C59.9958 45.1513 48.7647 57.6773 34.1746 59.7099C32.8104 59.8991 31.4147 59.9979 29.9979 59.9979C28.3625 59.9979 26.7566 59.8676 25.1927 59.6153C10.9095 57.3157 0 44.9306 0 30C0 13.4319 13.4319 0 30 0C46.5681 0 60 13.4319 60 30H59.9958Z",
    fill: "#1877F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1746 24.0892V30.6244H42.259L40.9788 39.4276H34.1746V59.71C32.8104 59.8992 31.4146 59.998 29.9979 59.998C28.3625 59.998 26.7566 59.8677 25.1927 59.6154V39.4276H17.7368V30.6244H25.1927V22.6283C25.1927 17.6675 29.2138 13.6443 34.1767 13.6443V13.6485C34.1914 13.6485 34.204 13.6443 34.2187 13.6443H42.2611V21.2578H37.006C35.4442 21.2578 34.1767 22.5253 34.1767 24.0871L34.1746 24.0892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircleLogo);
export default __webpack_public_path__ + "static/media/facebook_circle_logo.a789fff5cdca88f00facaae206e86499.svg";
export { ForwardRef as ReactComponent };